import { localization } from '@ocean/configs'
import { Workstation } from 'modules/simulatorTrainings/common/types/instructor'

const { i18n } = localization

class WorkstationUtils {
  generateWorkStations(count: number, prefix: string = ''): Workstation[] {
    const workstations = new Array(count)
      .fill(null)
      .map((_, i) => ({ id: `${i + 1}`, name: `${prefix}${prefix && ' '}Machine ${i + 1}` }))

    return this.addNotAssignedToWorkStations(workstations)
  }

  addNotAssignedToWorkStations(workstations: Workstation[]): Workstation[] {
    return [{ id: undefined, name: i18n.t<string>('common.notAssigned') }, ...workstations]
  }

  getAvailableWorkstations(
    workstations: Workstation[],
    assignedWorkstations: Record<string, string | undefined>
  ) {
    const assignedWorkstationIds = Object.values(assignedWorkstations).filter(Boolean)
    const workstationIds = workstations.map(({ id }) => id).filter(Boolean)
    return workstationIds.filter(id => !assignedWorkstationIds.includes(id))
  }
}

export default new WorkstationUtils()
